import { useRenameBreakdownDocument } from '@/hooks/useBreakdownDocuments';
import { NameTagDialog } from './NameTagDialog';

export interface RenameDocumentDialogProps {
  jobId: string;
  document: { id: string; name: string; tag?: string | null } | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RenameDocumentDialog({
  jobId,
  document,
  open,
  onOpenChange,
}: RenameDocumentDialogProps) {
  const rename = useRenameBreakdownDocument(jobId);

  return (
    <NameTagDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Rename version"
      submitLabel="Save"
      submittingLabel="Saving..."
      includeTag
      initialName={document?.name ?? ''}
      initialTag={document?.tag ?? ''}
      onSubmit={async ({ name, tag }) => {
        if (!document) return;
        await rename.mutateAsync({ docId: document.id, name, tag });
      }}
    />
  );
}
